export interface IModalPictureInfoState {
    info: Map<string, string>
}
export const initialModalPictureInfoState =
    (): IModalPictureInfoState => ({
        info: new Map()
    })
